import { atom } from 'jotai';

/**
 * Whether the current deal has an **active** Shopify catalog connection,
 * i.e. the Shopify plugin is installed and connected so live data can be
 * pulled from the store.
 *
 * Mirrors the deal-level value into atom-land (set from `useDeal`) so derived
 * atoms without access to the deal context (e.g. the duplicate-variant
 * anomaly buckets in `object-anomalies.state.ts`) can gate Shopify-only fixes.
 *
 * The component-side equivalent is `useShopifyConnectionState`.
 */
export const hasActiveShopifyConnectionAtom = atom<boolean>(false);
